import * as types from "./types";
import {
    getEmailTemplateAxios,
    deleteEmailTemplateAxios,
    postEmailTemplateAxios,
    putEmailTemplateAxios,
    getEmailTemplateByIdAxios,
    getPlatformTypeAxios,
    postContentTemplateAXios,
    getContentTemplateAxios,
    deleteContentTemplateAxios,
    getContentTemplateByIdAxios,
    putContentTemplateAxios
} from "./services";

export async function getEmailTemplateListAction({ commit }) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        const { data } = await getEmailTemplateAxios();
        commit(types.GET_EMAILTEMPLATE_LIST, data.result);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}

export async function removeEmailTemplateAction({ commit }, payload) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        await deleteEmailTemplateAxios(payload);
        commit(types.REMOVE_EMAILTEMPLATE, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}

export async function addEmailTemplateAction({ commit }, payload) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        await postEmailTemplateAxios(payload);
        commit(types.ADD_EMAILTEMPLATE, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}

export async function updateEmailTemplateAction({ commit }, payload) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        await putEmailTemplateAxios(payload);
        commit(types.UPDATE_EMAILTEMPLATE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}

export async function getEmailTemplateByIdAction({ commit }, payload) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        const { data } = await getEmailTemplateByIdAxios(payload);
        commit(types.GET_EMAILTEMPLATEID, data.result);

    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}

export async function getPlatformTypeAction({ commit }) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        const { data } = await getPlatformTypeAxios();
        commit(types.GET_PLATFORM_TYPE, data);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}

export async function addContentTemplateAction({ commit }, payload) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        const response = await postContentTemplateAXios(payload);
        commit(types.ADD_CONTENT_TEMPLATE, payload);
        
        return { data: response }; 
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}

export async function getContentTemplateAction({ commit }) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        const { data } = await getContentTemplateAxios();

        if (data) {
            commit(types.GET_CONTENT_TEMPLATE, data);
        } else {
            commit(types.GET_CONTENT_TEMPLATE, []);
        }
        return data;
    }
    catch (e) {
        console.error("Error fetching templates:", e);
        commit(types.GET_CONTENT_TEMPLATE, []);
        throw e;
    }
    finally {
        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}



export async function deleteContentTemplateAction({ commit }, payload) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        await deleteContentTemplateAxios(payload);
        commit(types.DELETE_CONTENT_TEMPLATE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}

export async function getContentTemplateByIdAction({ commit }, id) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        const { data } = await getContentTemplateByIdAxios(id);
        commit(types.GET_CONTENT_TEMPLATE_BY_ID, data);
        return data
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}


export async function updateContentTemplateAction({ commit }, { id, payload }) {
    commit(types.LOADING_EMAILTEMPLATE, true);
    try {
        await putContentTemplateAxios(id, payload);
        commit(types.UPDATE_CONTENT_TEMPLATE, payload);
    } catch (e) {
        throw e;
    } finally {
        commit(types.LOADING_EMAILTEMPLATE, false);
    }
}